import { Badge } from "@bednbody/ui/components/badge";
import { Button } from "@bednbody/ui/components/button";
import { Card, CardContent, CardHeader, CardTitle } from "@bednbody/ui/components/card";
import { cn } from "@bednbody/ui/lib/utils";
import type { Icon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionCardProps {
  title: string;
  icon: Icon;
  children: ReactNode;
  viewAllHref?: string;
  badge?: string;
  /** Right-side header slot for controls (e.g. a Weekly/Today toggle). */
  actions?: ReactNode;
  className?: string;
}

export function SectionCard({
  title,
  icon: Icon,
  children,
  viewAllHref,
  badge,
  actions,
  className = "",
}: SectionCardProps) {
  return (
    <Card className={cn("rounded-xl", className)}>
      <CardHeader className="flex items-start justify-between gap-2">
        <CardTitle className="flex min-w-0 items-center gap-2">
          <Icon weight="duotone" className="size-5 shrink-0 text-primary" />
          <h2 className="truncate type-title-body">{title}</h2>
          {badge ? (
            <Badge variant="warning-soft" shape="soft" className="shrink-0">
              {badge}
            </Badge>
          ) : null}
        </CardTitle>
        {viewAllHref ? (
          <Button variant="secondary" render={<Link to={viewAllHref}>View all</Link>} />
        ) : null}
      </CardHeader>
      <CardContent>
        {actions}
        {children}
      </CardContent>
    </Card>
  );
}
